import { render } from "./CourseSubpage.vue?vue&type=template&id=9328c5b4&scoped=true"
import script from "./CourseSubpage.vue?vue&type=script&lang=js"
export * from "./CourseSubpage.vue?vue&type=script&lang=js"

import "./CourseSubpage.vue?vue&type=style&index=0&id=9328c5b4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9328c5b4"]])

export default __exports__